// extracted by mini-css-extract-plugin
export default {"container":"ProjectDetails_container__OFoL9","empty":"ProjectDetails_empty__lZNFA"};